'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isArray;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isArray.js
// module id = 842
// module chunks = 0